import { useLayoutEffect, useRef } from "react";
import isEqual from "lodash/isEqual";
import { VISUALIZATION_TABLE_HEADER_HEIGHT } from "views/Constants";
import { isInfiniteScrollUp, isInfiniteScrollDown } from "logview/helpers";
import { LOADING_ROW_HEIGHT } from "../LogViewTable";
export default ({
  tableRef,
  tableHeaderRef,
  pageRefs,
  lastPositionRef,
  scrollPositionUpdate,
  infiniteScrollDirection,
  setFinishedScrollPositionUpdate
}) => {
  const prevScrollPositionUpdate = useRef(scrollPositionUpdate);
  useLayoutEffect(() => {
    let scrollPositionAnimation;
    if (!isEqual(prevScrollPositionUpdate.current, scrollPositionUpdate)) {
      const { targetPage, direction, targetPageOffsetTop, loadedAllPrevMessages } = scrollPositionUpdate;
      const updateScrollPosition = () => {
        var _a;
        const targetPageRef = targetPage ? pageRefs.current[targetPage] : void 0;
        const loadingRowHeight = loadedAllPrevMessages ? 0 : LOADING_ROW_HEIGHT;
        if (targetPageRef) {
          const upTopOffset = lastPositionRef.current + targetPageRef.offsetTop;
          const downTopOffset = lastPositionRef.current - targetPageOffsetTop;
          const tableHeaderHeight = ((_a = tableHeaderRef.current) == null ? void 0 : _a.offsetHeight) || VISUALIZATION_TABLE_HEADER_HEIGHT;
          if (isInfiniteScrollUp(infiniteScrollDirection)) {
            const staticElementsHeight = loadingRowHeight + tableHeaderHeight;
            if (direction === "up") {
              tableRef.current.scrollTop = upTopOffset - staticElementsHeight;
            }
            if (direction === "down") {
              tableRef.current.scrollTop = downTopOffset + staticElementsHeight;
            }
          }
          if (isInfiniteScrollDown(infiniteScrollDirection)) {
            if (direction === "up") {
              tableRef.current.scrollTop = upTopOffset - tableHeaderHeight;
            }
            if (direction === "down") {
              tableRef.current.scrollTop = downTopOffset + tableHeaderHeight;
            }
          }
        }
        prevScrollPositionUpdate.current = scrollPositionUpdate;
      };
      scrollPositionAnimation = requestAnimationFrame(updateScrollPosition);
      setFinishedScrollPositionUpdate(true);
    }
    return () => {
      if (scrollPositionAnimation) {
        cancelAnimationFrame(scrollPositionAnimation);
      }
    };
  }, [
    tableRef,
    tableHeaderRef,
    pageRefs,
    prevScrollPositionUpdate,
    scrollPositionUpdate,
    lastPositionRef,
    setFinishedScrollPositionUpdate,
    infiniteScrollDirection
  ]);
};
